import React from 'react';
import { func } from 'prop-types';
import { NavigationControl } from 'react-map-gl';
import styled from 'styled-components';
import MapLegend from './MapLegend';

const ControlsContainer = styled.div`
  position: absolute;
  right: 8px;

  & .mapboxgl-ctrl-group {
    border-radius: 2px;
  }

  & .mapboxgl-ctrl-compass {
    display: none;
  }
`;

const LegendContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 7px;
`;

const MapControls = ({ onViewportChange }) => (
  <React.Fragment>
    <LegendContainer>
      <MapLegend />
    </LegendContainer>
    <ControlsContainer className="mapControls">
      <NavigationControl onViewportChange={onViewportChange} />
    </ControlsContainer>
  </React.Fragment>
);

MapControls.propTypes = {
  onViewportChange: func.isRequired,
};

export default MapControls;



// WEBPACK FOOTER //
// ./src/components/MapPage/MapControls.jsx